import React, { useState } from 'react';
import { pdf } from '@react-pdf/renderer';

import encabezadoImg from './informes/encabezado_A4.png';
import pieImg from './informes/pie_hoja_A4.png';
import NoObjecionDocumentoPDF, { limpiarDireccion } from './NoObjecionDocumentoPDF';

const NoObjecionPDF = ({ beneficiary, obraData, onClose }) => {
    const [isLoading, setIsLoading] = useState(false);

    const {
        nombre_beneficiario,
        documento,
        direccion,
        barrio,
        localidad,
        monto,
    } = beneficiary || {};

    const {
        nombre_obra,
        partido_nombre,
        area_responsable,
        programa_lineamiento,
        tipo_subsidio,
    } = obraData?.datosGenerales || obraData || {};

    const expediente = obraData?.array_obras_expediente?.find(
        item => item.objeto_o === "Proyecto"
    )?.expediente_o || '';

    const handleDownloadPDF = async () => {
        try {
            setIsLoading(true);

            const blob = await pdf(
                <NoObjecionDocumentoPDF
                    datos={{
                        nombre_obra,
                        expediente,
                        partido_nombre,
                        programa_lineamiento,
                        area_responsable,
                        nombre_beneficiario,
                        documento,
                        direccion,
                        barrio,
                        localidad,
                        monto,
                        fecha_emision: new Date().toLocaleDateString('es-AR'),
                    }}
                />
            ).toBlob();

            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const safeName = (nombre_beneficiario || 'beneficiario')
                .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                .replace(/[^a-zA-Z0-9 ]/g, '').trim();
            a.download = `no_objecion_${safeName}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error al generar PDF:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={onClose}>
            <div className="w-[90vw] h-[90vh] bg-white rounded-lg shadow-xl overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                <div className="sticky top-0 bg-white border-b z-10 flex items-center justify-between px-6 py-3">
                    <h2 className="text-lg font-semibold">Planilla de No Objeción</h2>
                    <div className="flex gap-2">
                        <button
                            onClick={handleDownloadPDF}
                            disabled={isLoading}
                            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500 disabled:opacity-50"
                        >
                            {isLoading ? (
                                <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" />
                            ) : (
                                <svg className="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
                                </svg>
                            )}
                            Descargar PDF
                        </button>
                        <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl leading-none">&times;</button>
                    </div>
                </div>

                <div className="p-10 mx-auto flex flex-col overflow-hidden" style={{ width: '800px', height: '1131px' }}>
                    <div className="shrink-0">
                        <img src={encabezadoImg} alt="Encabezado" className="w-full h-auto" />
                    </div>

                    <div className="text-center mb-6 shrink-0">
                        <h1 className="text-2xl font-bold text-gray-800 mb-1">Planilla de No Objeción</h1>
                        <p className="text-sm text-gray-500">Dirección Provincial de Intervenciones Complementarias</p>
                    </div>

                    <div className="py-4 border-b border-gray-300 space-y-2 text-sm shrink-0">
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <p><strong>Proyecto:</strong> {nombre_obra || '-'}</p>
                                <p><strong>Expediente:</strong> {expediente || '-'}</p>
                                <p><strong>Partido:</strong> {partido_nombre || '-'}</p>
                            </div>
                            <div>
                                <p><strong>Programa:</strong> {programa_lineamiento || '-'}</p>
                                <p><strong>Área Responsable:</strong> {area_responsable || '-'}</p>
                                {/*<p><strong>Fecha:</strong> {new Date().toLocaleDateString('es-AR')}</p>*/}
                            </div>
                        </div>
                    </div>

                    <div className="py-4 border-b border-gray-300 text-sm shrink-0">
                        <h3 className="text-base font-semibold mb-2">Datos del Beneficiario</h3>
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <p><strong>Nombre:</strong> {nombre_beneficiario || '-'}</p>
                                <p><strong>Documento:</strong> {documento || '-'}</p>
                                <p><strong>Domicilio:</strong> {limpiarDireccion(direccion)}</p>
                            </div>
                            <div>
                                <p><strong>Barrio:</strong> {barrio || '-'}</p>
                                <p><strong>Localidad:</strong> {localidad || '-'}</p>
                                <p><strong>Monto:</strong> {monto ? `$${Number(monto).toLocaleString('es-AR')}` : '-'}</p>
                            </div>
                        </div>
                    </div>

                    <div className="py-4 text-sm shrink-0">
                        <p className="mb-3">
                            Por medio de la presente, se deja constancia que no existen objeciones técnicas ni administrativas
                            para que el/la beneficiario/a <strong>{nombre_beneficiario || '-'}</strong> acceda al subsidio
                            correspondiente en el marco del proyecto <strong>{nombre_obra || '-'}</strong>.
                        </p>
                        <p>
                            Se otorga la presente No Objeción a los efectos de continuar con el trámite administrativo
                            correspondiente.
                        </p>
                    </div>

                    <div className="mt-auto shrink-0">
                        {/*iv className="grid grid-cols-2 gap-16 text-sm text-center">
                            <div>
                                <div className="border-t border-gray-400 pt-2">
                                    <p className="font-medium">Firma y Sello</p>
                                    <p className="text-xs text-gray-500">Autorizante</p>
                                </div>
                            </div>
                            <div>
                                <div className="border-t border-gray-400 pt-2">
                                    <p className="font-medium">Firma y Sello</p>
                                    <p className="text-xs text-gray-500">Beneficiario/a</p>
                                </div>
                            </div>
                        </div>*/}
                        <div className="text-right text-sm text-gray-500 mt-4">
                            <p>Fecha de emisión: {new Date().toLocaleDateString('es-AR')}</p>
                        </div>
                    </div>

                    <div className="shrink-0">
                        <img src={pieImg} alt="Pie de página" className="w-full h-auto" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NoObjecionPDF;
